import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { object } from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import { Card, CardBody, CardHeader, Chip, Button, Spinner, Input } from "@heroui/react";
import { DocumentArrowDownIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";
import { ETA_TIME } from "utils/constant";

const CustomerBookReport: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const navigator = useNavigate();
  const tableRef = useRef(null);

  const [tableData, setTableData] = useState<any>([]);
  const [agentId, setAgentId] = useState("");
  const [startDate, setStartDate] = useState<any>(moment().startOf("day").subtract(1, "days").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").format("YYYY-MM-DD"));
  const [query, setQuery] = useState<any>({
    /*date: {
      $gte: moment().startOf("day").subtract(7, "days"),
      $lte: moment().endOf("day"),
    },*/
    qry: `date >= '${moment().startOf("day").subtract(1, "days").format("YYYY-MM-DD HH:mm:ss")}' AND date <= '${moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss")}'`,
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [isDataAdded, setIsDataAdded] = useState(false);

  const [nestedTables, setNestedTables] = useState<any>({});
  const [nestedSelectedOptions, setNestedSelectedOptions] = useState<any>({});

  let hardcode_json_data = [
    { status_code: 0, reason: "Shipment Delivered", action: "Success" },
    { status_code: 1, reason: "residence/office closed", action: "Re-Assign" },
    { status_code: 2, reason: "add incomplete/incorrect/not locatable", action: "Re-Assign" },
    { status_code: 3, reason: "no such consignee at given address", action: "Re-Assign" },
    { status_code: 4, reason: "consignee refused to accept", action: "Re-Assign" },
    { status_code: 5, reason: "RTO ( shipper request )", action: "Return" },
    { status_code: 6, reason: "need dept name/extn.no:unable to deliver", action: "Re-Assign" },
    { status_code: 7, reason: "consignee not available", action: "Re-Assign" },
    { status_code: 8, reason: "IN TRANSIT", action: "Re-Assign" },
    { status_code: 9, reason: "hold at location", action: "Re-Assign" },
    { status_code: 10, reason: "out of delivery area", action: "Re-Assign" },
    { status_code: 11, reason: "disturbance/natural disaster/strike ", action: "Re-Assign" },
    { status_code: 12, reason: "shipment handed over to agent/subcouriered pod no available", action: "Success" },
    { status_code: 13, reason: "consginee/shipper not ready to pay tax/demurrag ", action: "Re-Assign" },
    { status_code: 14, reason: "held at hub:regulatory paperwork reqd", action: "Re-Assign" },
    { status_code: 15, reason: "Shipment Missrouted due to wrong pincode/adddress", action: "Return" },
    { status_code: 16, reason: "shipment redirected on same airwaybill", action: "Re-Assign" },
    { status_code: 17, reason: "shipment redirected on new airwaybill", action: "Return" },
    { status_code: 18, reason: "held for duty/taxes/fees payment", action: "Re-Assign" },
    { status_code: 19, reason: "consigment partially deliverd", action: "Success" },
    { status_code: 20, reason: "shipment/piece missing", action: "Destroy" },
    { status_code: 21, reason: "shipment returned back to shipper", action: "CANCEL" },
    { status_code: 22, reason: "delivery area not accessible", action: "Re-Assign" },
    { status_code: 23, reason: "shipment partially deliverd", action: "Re-Assign" },
    { status_code: 24, reason: "please contact customer service", action: "Re-Assign" },
    { status_code: 25, reason: "attempt at secondary address", action: "Re-Assign" },
    { status_code: 26, reason: "shipment destroyed/sent for disposal", action: "Destroy" },
    { status_code: 27, reason: "UnDelivered", action: "Re-Assign" },
  ];
  hardcode_json_data[99] = { status_code: 99, reason: "Shipment Cancelled", action: "CANCEL" };
  hardcode_json_data[100] = { status_code: 100, reason: "Sent To Third Party", action: "Success" };
  const [HARDCODE_JSON_STATUS_LIST] = useState<any>(hardcode_json_data);

  let HARDCORE_MBAG_STATUS = [
    { status_code: 0, reason: "PENDING" },
    { status_code: 1, reason: "flight delay due to bad weather" },
    { status_code: 2, reason: "late arrival scheduled.for next working day" },
    { status_code: 3, reason: "missed connection" },
    { status_code: 4, reason: "shipment off-loaded by airline security/space contraint" },
    { status_code: 5, reason: "flight/vehicle delayed cancelled" },
    { status_code: 6, reason: "misrouted in network" },
    { status_code: 7, reason: "scheduled for movement in network" },
    { status_code: 8, reason: "linehaul delayed accident/traffic-jam" },
    { status_code: 9, reason: "security cleared" },
    { status_code: 10, reason: "shipment under cooling by airline" },
    { status_code: 11, reason: "under security investigation" },
    { status_code: 12, reason: "please contact customer service" },
    { status_code: 13, reason: "shipment detained/seized by regulatory" },
    { status_code: 14, reason: "awaiting connection on next available flight" },
    { status_code: 15, reason: "Shipment Held by GST Deparment under investigation" },
  ];

  const defaultOptions: any = [{ value: 0, label: "Loading..." }];
  type OptionType = {
    value: number;
    label: string;
  };
  const columnData = [
    {
      label: "Reference Code",
      key: "pickup_code",
      type: ADT.TEXT,
    },
    {
      label: "Product",
      key: "product",
      type: ADT.DB,
      db: "product",
      db_col: "product_name",
    },
    {
      label: "Origin City",
      key: "org_city",
      type: ADT.DB,
      db: "city",
      db_col: "city_name",
    },
    {
      label: "Destination City",
      key: "dest_city",
      type: ADT.DB,
      db: "city",
      db_col: "city_name",
    },

    {
      label: "Dox/Non Dox",
      key: "isdoc",
      type: ADT.SELECT,
      options: [
        { value: "0", label: "NON DOX" },
        { value: "1", label: "DOX" },
      ],
    },

    {
      label: "Shipper",
      key: "shipper",
      type: ADT.TEXT,
    },
    {
      label: "Consignee",
      key: "consignee",
      type: ADT.TEXT,
    },
    {
      label: "Holiday",
      key: "holiday",
      type: ADT.SELECT,
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    },
    {
      label: "10:30",
      key: "ten_30",
      type: ADT.SELECT,
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    },
    {
      label: "Status",
      key: "status",
      type: ADT.SELECT,
      options: [
        { value: "0", label: "Delivered" },
        { value: "-1", label: "Non Delivered" },
        { value: "99", label: "Cancelled" },
        { value: "5", label: "RTO" },
      ],
    },
  ];

  useEffect(() => {
    let proms = [];

    let nestedApiData = {};
    columnData.forEach((cd) => {
      if (cd.type == ADT.DB) {
        proms.push(
          new Promise((res, rej) => {
            ListCommanWay(`/admin/${cd.db}/list`, {}, { paginate: 1000 })
              .then((x) => {
                let data: OptionType[] = [];
                if (x.status == "SUCCESS") {
                  let ary = [...x.data.data];

                  data = ary.map((d) => {
                    if (cd.db == "country") {
                      return { value: d.country_code, label: d[cd.db_col] };
                    } else if (cd.db == "product") {
                      return { value: d.product_code, label: d[cd.db_col] };
                    } else if (cd.db == "city") {
                      return { value: d[cd.db_col], label: d[cd.db_col] };
                    } else {
                      return { value: d.id, label: d[cd.db_col] };
                    }
                  });
                  nestedApiData[cd.db] = data;
                }
                res(1);
              })
              .catch((c) => {
                res(0);
              });
          }),
        );
      }
    });

    Promise.all(proms).then((x) => {
      setNestedTables(nestedApiData);
    });
  }, []);

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_booking_report_list"],
    () =>
      ListCommanWay(
        "/admin/booking/list",
        {
          ...query,
          qry2: values,
        },
        {},
      ),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data);
          setTableData(data.data.data);
        } else {
          setTableData([]);
        }
      },
      onError: (data) => {
        setTableData([]);
      },
    },
  );

  useEffect(() => {
    refetch();
  }, [query]);

  const __handleSubmit = async () => {
    setIsDataAdded(!isDataAdded);

    setQuery({
      qry: `date >= '${startDate ? startDate : moment().startOf("day").subtract(7, "days").format("YYYY-MM-DD HH:mm:ss")}' AND date <= '${
        endDate ? endDate : moment().endOf("day").format("YYYY-MM-DD HH:mm:ss")
      }'`,
    });

    /*setQuery({
      //agent_id: Number(agentId),
      date: {
        $gte: startDate ? startDate : moment().startOf("day").subtract(7, "days"),
        $lte: endDate ? endDate : moment().endOf("day"),
      },
    });*/
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});

  const { handleSubmit, handleBlur, values, handleChange, errors, setValues, touched, setFieldValue } = useFormik({
    validationSchema: object().shape({}),
    initialValues: {
      pickup_code: "",
      customerCode: "",
      product: "",
      org_city: "",
      dest_city: "",
      isdoc: "",
      shipper: "",
      consignee: "",
      holiday: "",
      ten_30: "",
      status: "",
    },
    onSubmit: async (values, { resetForm }) => {
      console.log("valuesssss", values);
    },
  });

  const getStatusText = (lastMsg: any = "", r) => {
    const isPickup = r.awb_no ? false : true;

    if (isPickup) {
      return ["Pickup Processed", "Pickup Done", "Pickup Cancel", "Pickup Reschedule", "Confirmed"][r.status] || "-";
    } else {
      if (
        lastMsg.includes("Motherbag Tally") ||
        lastMsg.includes("Motherbag Out-Scan") ||
        lastMsg.includes("Motherbag In-Scan") ||
        (lastMsg || "").toLowerCase().includes("send to thirdparty") ||
        (lastMsg || "").toLowerCase().includes("sent to thirdparty")
      ) {
        let msg = "In Transit";
        return msg;
      } else if(lastMsg.includes("DRS Generated")){
        return "Out for Delivery";
      } 
      else {
        return lastMsg;
      }
    }
    //let lastMsg = resData.tracking_data[resData.tracking_data.length - 1]?.message_code;
  };

  const getETAText = (etaHours: number | undefined, bookingDate: any, podMessage: string = "") => {
    if (!etaHours || etaHours <= 0) return "-";
    
    let days = Math.ceil(etaHours / 24);
    
    // Check if tracking contains delay messages that require extra day
    const delayMessages = [
      "flight delay due to bad weather",
      "late arrival scheduled.for next working day",
      "shipment off-loaded by airline security/space contraint"
    ];
    
    const hasDelayMessage = delayMessages.some(msg => 
      (podMessage || "").toLowerCase().includes(msg.toLowerCase())
    );
    
    // Add 1 extra day if delay message is found
    if (hasDelayMessage) {
      days += 1;
    }
    
    let currentDate = moment(bookingDate);
    let deliveryDate = currentDate.clone();
    let daysAdded = 0;
    
    // Add days while skipping Sundays
    while (daysAdded < days) {
      deliveryDate.add(1, 'day');
      if (deliveryDate.day() !== 0) { // 0 = Sunday
        daysAdded++;
      }
    }
    
    const today = moment().startOf('day');
    const tomorrow = moment().add(1, 'day').startOf('day');
    const deliveryDateStart = deliveryDate.startOf('day');
    
    if (deliveryDateStart.isSame(today, 'day')) {
      return "Arriving Today";
    } else if (deliveryDateStart.isSame(tomorrow, 'day')) {
      return "Arriving Tomorrow";
    } else {
      const dayOfMonth = deliveryDate.format('Do');
      const monthName = deliveryDate.format('MMM');
      return `Arriving on ${dayOfMonth} ${monthName}`;
    }
  };

  const exportToExcel = () => {
    const table = document.getElementById("myTable");

    const ws = utils.table_to_sheet(table);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Booking Report.xlsx");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 font-inter">
      {/* Header */}
      <div className="bg-gradient-to-r from-slate-800 via-slate-700 to-slate-800 px-6 py-4 shadow-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white/10 backdrop-blur rounded-xl flex items-center justify-center">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <div>
              <h1 className="text-xl font-bold text-white">Booking Report</h1>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Chip color="primary" variant="flat" className="bg-white/10 text-white">
              {tableData.length} Records
            </Chip>
          </div>
        </div>
      </div>

      {/* Filters Card */}
      <div className="px-4 -mt-4">
        <Card className="shadow-xl border-none overflow-visible">
          <CardBody className="p-4 overflow-visible">
            <form
              className="flex flex-col gap-4"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(e);
              }}
            >
              {/* Compact Inline Filters */}
              <div className="flex flex-wrap items-end gap-3">
                <AfDateRangePicker
                  label="Date Range"
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                />
                {columnData.map((c) => {
                  switch (c.type) {
                    case ADT.NUMBER:
                      return (
                        <Input
                          key={"general_" + c.key}
                          type="number"
                          label={c.label}
                          placeholder={c.label}
                          size="sm"
                          variant="bordered"
                          className="w-48"
                          name={c.key}
                          value={values[c.key]}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onWheel={handleWheel}
                          isInvalid={touched[c.key] && Boolean(errors[c.key])}
                          errorMessage={touched[c.key] && errors[c.key] ? errors[c.key] + "" : ""}
                        />
                      );
                      break;
                    case ADT.TEXT:
                      return (
                        <div key={"general_" + c.key} className="w-36">
                          <Input
                            type="text"
                            label={c.label}
                            labelPlacement="outside-top"
                            size="sm"
                            variant="bordered"
                            classNames={{
                              input: "border-none",
                              inputWrapper: "bg-slate-50 h-8",
                              label: "text-xs",
                            }}
                            name={c.key}
                            value={values[c.key]}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched[c.key] && Boolean(errors[c.key])}
                            errorMessage={touched[c.key] && errors[c.key] ? errors[c.key] + "" : ""}
                          />
                        </div>
                      );
                      break;
                    case ADT.DB:
                      return (
                        <div key={"general_" + c.key} className="w-48">
                          <label className="block mb-1 text-xs font-medium text-slate-600">{c.label}</label>
                          <Select
                            key={"select-" + (nestedTables[c.db] ? nestedTables[c.db].length : "undef")}
                            className="text-sm z-40"
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: "32px",
                                height: "32px",
                                fontSize: "0.875rem",
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                height: "32px",
                                padding: "0 6px",
                              }),
                              input: (base) => ({
                                ...base,
                                margin: "0px",
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                height: "32px",
                              }),
                            }}
                            id={"general_" + c.key}
                            options={nestedTables[c.db] ? nestedTables[c.db] : defaultOptions}
                            onChange={(el) => {
                              setFieldValue(c.key, el?.value || "");
                            }}
                            isClearable={true}
                            name={c.key}
                            value={nestedSelectedOptions[c.db]}
                          />
                          {touched[c.key] && errors[c.key] && <p className="mt-1 text-xs text-red-600">{errors[c.key] + ""}</p>}
                        </div>
                      );
                      break;
                    case ADT.SELECT:
                      return (
                        <div key={"general_" + c.key} className="w-48">
                          <label className="block mb-1 text-xs font-medium text-slate-600">{c.label}</label>
                          <Select
                            key={"select-" + c.key}
                            className="text-sm z-40"
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: "32px",
                                height: "32px",
                                fontSize: "0.875rem",
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                height: "32px",
                                padding: "0 6px",
                              }),
                              input: (base) => ({
                                ...base,
                                margin: "0px",
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                height: "32px",
                              }),
                            }}
                            id={"general_" + c.key}
                            options={c?.options}
                            onChange={(el) => {
                              setFieldValue(c.key, el?.value || "");
                            }}
                            isClearable={true}
                            name={c.key}
                            value={nestedSelectedOptions[c.db]}
                          />
                          {touched[c.key] && errors[c.key] && <p className="mt-1 text-xs text-red-600">{errors[c.key] + ""}</p>}
                        </div>
                      );
                      break;
                    case ADT.TEXTAREA:
                      break;
                    case ADT.DATETIME:
                      break;
                    case ADT.FILE:
                      break;
                    default:
                      return <></>;
                      break;
                  }
                })}

                {/* Action Buttons inline */}
                <Button
                  size="sm"
                  variant="flat"
                  color="primary"
                  className="h-8 mt-5"
                  startContent={<DocumentArrowDownIcon className="w-4 h-4" />}
                  onPress={exportToExcel}
                >
                  Export
                </Button>
                <Button
                  size="sm"
                  color="success"
                  className="h-8 mt-5"
                  type="button"
                  onPress={__handleSubmit}
                  isLoading={isLoading || isFetching}
                  startContent={!isLoading && !isFetching && <MagnifyingGlassIcon className="w-4 h-4" />}
                >
                  Search
                </Button>
              </div>
            </form>
          </CardBody>
        </Card>
      </div>

      {/* Results Table */}
      <div className="px-4 mt-4 pb-8">
        <Card className="shadow-xl border-none overflow-hidden">
          <CardHeader className="bg-gradient-to-r from-slate-50 to-white border-b border-slate-100 px-4 py-3">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                </svg>
              </span>
              <h2 className="text-lg font-bold text-slate-800">Results</h2>
              {tableData.length > 0 && (
                <Chip size="sm" variant="flat" color="primary" className="ml-2">
                  {tableData.length} shipments
                </Chip>
              )}
            </div>
          </CardHeader>
          <CardBody className="p-0 overflow-x-auto">
            <table className="w-full text-sm" ref={tableRef} id="myTable">
              <thead className="bg-slate-50 sticky top-0">
                <tr>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    Date
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    Ref No
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    Airwaybill
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    Shipper
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    Origin
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    Consignee
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    Destination
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    Status
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    ETA
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    Receiver Time
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    Receiver Name
                  </th>
                </tr>
              </thead>
              <tbody>
                {(isLoading || isFetching) && (
                  <tr>
                    <td colSpan={10} className="text-center py-12">
                      <Spinner size="lg" color="primary" />
                      <p className="text-slate-500 mt-2">Loading data...</p>
                    </td>
                  </tr>
                )}
                {!isLoading && !isFetching && !tableData.length && (
                  <tr>
                    <td colSpan={10} className="text-center py-12">
                      <div className="flex flex-col items-center">
                        <svg className="w-16 h-16 text-slate-300 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1.5}
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          />
                        </svg>
                        <p className="text-slate-600 font-medium">No records found</p>
                        <p className="text-slate-400 text-sm mt-1">Try adjusting your search filters</p>
                      </div>
                    </td>
                  </tr>
                )}
                {!isLoading &&
                  !isFetching &&
                  tableData.map((r, i) => {
                    return (
                      <tr className="hover:bg-slate-50 transition-colors border-b border-slate-200" key={"book-report-" + i}>
                        <td className="px-3 py-2 text-slate-600 border-r border-slate-100">{moment(r.date).format("DD/MM/YYYY")}</td>
                        <td className="px-3 py-2 text-slate-800 text-xs border-r border-slate-100">{r.pickup_code}</td>
                        <td className="px-3 py-2 border-r border-slate-100">
                          <a
                            target="_blank"
                            href={`/customer-pod/tracking?awb=${r.awb_no}`}
                            className="text-blue-600 hover:text-blue-800 font-medium"
                          >
                            {r.awb_no}
                          </a>
                        </td>
                        <td className="px-3 py-2 font-medium text-slate-800 border-r border-slate-100">{r.shipper_sh}</td>
                        <td className="px-3 py-2 text-slate-600 border-r border-slate-100">{r.shipper_city}</td>
                        <td className="px-3 py-2 text-slate-600 border-r border-slate-100">{r.consignee}</td>
                        <td className="px-3 py-2 text-slate-600 border-r border-slate-100">{r.destination}</td>
                        <td className="px-3 py-2 border-r border-slate-100">
                          <Chip size="sm" color={r.status == 0 ? "success" : "default"} variant="flat">
                            {getStatusText(r.pod_message?.replaceAll("0 - ", "") || r.status, r)}
                          </Chip>
                        </td>
                        <td className="px-3 py-2 text-slate-600 text-xs border-r border-slate-100">
                          {r.status == 0 ? "-" : getETAText(ETA_TIME[`${r.shipper_city}_${r.destination}`], r.date, r.pod_message)}
                        </td>
                        <td className="px-3 py-2 text-slate-600 text-xs whitespace-nowrap border-r border-slate-100">
                          {(r.status == 0 && r.pod_updatedAt && (moment(r.pod_updatedAt).format("DD/MM/YYYY HH:mm") || "0")) || "-"}
                        </td>
                        <td className="px-3 py-2 text-slate-600 text-xs">{r.receiver}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default CustomerBookReport;
